export const NAME = 'assetUploader';
